// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1aib_","consentsList":"PatientConsents_consentsList__3Av4f","consentsListEmpty":"PatientConsents_consentsListEmpty__3gGgp"};